import React from 'react';
import { Button } from '@/components/ui';
import { ProfileApiResponse } from '@/lib/api/services/admin-user';

type AdminUser = ProfileApiResponse[0];
interface BlockUnblockModalProps {
    isOpen: boolean;
    member: AdminUser;
    action: 'block' | 'unblock';
    onClose: () => void;
    onConfirm: () => void;
    isProcessing?: boolean;
}

const BlockUnblockModal: React.FC<BlockUnblockModalProps> = ({
    isOpen,
    member,
    action,
    onClose,
    onConfirm,
    isProcessing = false,
}) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
        >
            <div className="bg-white rounded-xl shadow-lg w-full max-w-lg m-4" onClick={(e) => e.stopPropagation()}>
                <div className="p-8 text-center">
                    <div className="mx-auto mb-4 w-20 h-20 flex items-center justify-center">
                        <div className={`w-20 h-20 rounded-full flex items-center justify-center ${action === 'block' ? 'bg-red-100' : 'bg-green-100'}`}>
                            <svg className={`w-10 h-10 ${action === 'block' ? 'text-red-600' : 'text-green-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {action === 'block' ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                )}
                            </svg>
                        </div>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800">
                        {action === 'block' ? 'Block' : 'Unblock'} Member?
                    </h2>
                    <p className="text-sm text-gray-500 mt-2 max-w-sm mx-auto">
                        Are you sure you want to {action} {member.firstName} {member.lastName}?
                        {action === 'block' ? ' They will lose access to the system.' : ' They will regain access to the system.'}
                    </p>
                    <div className="flex justify-center gap-4 mt-8">
                        <Button
                            variant={action === 'block' ? 'danger' : 'primary'}
                            onClick={onConfirm}
                            disabled={isProcessing}
                        >
                            {isProcessing ? 'Processing...' : action === 'block' ? 'Block' : 'Unblock'}
                        </Button>
                        <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlockUnblockModal;
